import script from "./RecordPaymentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecordPaymentModal.vue?vue&type=script&setup=true&lang=ts"

import "./RecordPaymentModal.vue?vue&type=style&index=0&id=075d6044&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-075d6044"]])

export default __exports__